import { createAction, createReducer } from '@reduxjs/toolkit';
import Actions from 'Actions';
import { StorytellerState } from 'store/StorytellerReduxState';

export const loginButtonClick = createAction(Actions.LOGIN_BUTTON_CLICK);
export const sessionValid = createAction<boolean>(Actions.SESSION_VALID);
export const loginInProgress = createAction<boolean>(Actions.LOGIN_IN_PROGRESS);
export const setCookieCheckIntervalId = createAction<NodeJS.Timeout | null>(
  Actions.SET_COOKIE_CHECK_INTERVAL_ID,
);

export interface UserSessionState {
  isSessionValid: boolean;
  loginInProgress: boolean;
  options: {
    sessionCheckDebounceMilliseconds: number;
    cookieCheckIntervalMilliseconds: number;
  };
  cookieCheckIntervalId: NodeJS.Timeout | null;
}

const initialState: UserSessionState = {
  isSessionValid: true,
  loginInProgress: false,
  options: {
    sessionCheckDebounceMilliseconds: 250,
    cookieCheckIntervalMilliseconds: 5000,
  },
  cookieCheckIntervalId: null,
};

export const userSessionReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loginButtonClick, (state) => {
      state.loginInProgress = true;
    })
    .addCase(sessionValid, (state, action) => {
      state.isSessionValid = action.payload;
      state.loginInProgress = false;
    })
    .addCase(loginInProgress, (state, action) => {
      state.loginInProgress = action.payload;
    })
    .addCase(setCookieCheckIntervalId, (state, action) => {
      state.cookieCheckIntervalId = action.payload;
    });
});

export const userSessionSelector = (state: StorytellerState) => state.userSession;

export const selectIsSessionValid = (state: StorytellerState) => userSessionSelector(state).isSessionValid;

export const selectIsLoginInProgress = (state: StorytellerState) =>
  userSessionSelector(state).loginInProgress;

export const selectUserSessionOptions = (state: StorytellerState) => userSessionSelector(state).options;

export const selectCookieCheckIntervalId = (state: StorytellerState) =>
  userSessionSelector(state).cookieCheckIntervalId;
